import { API_URL } from "constants";
import logger from "utils/logger";

export default async function cancelStripeIntent(body) {
  const res = await fetch(API_URL + "/payments/cancelStripeIntent", {
    method: "POST",
    body: JSON.stringify(body),
  });

  const resJson = await res.json();
  logger.log("resJson.data", resJson.data);

  return resJson.statusCode === 200
    ? { ...resJson.data, status: true }
    : { status: false };
}
